export default "<button type=\"button\" class=\"btn {{class_}}\" data-dismiss=\"modal\">{{label}}</button>";